import type { FC, SyntheticEvent } from "react";
import { memo, useCallback, useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";

import { ReactComponent as ArrowDown } from "@src/core/icons/arrow_drop_down.svg";
import { ReactComponent as Add } from "@src/core/icons/add.svg";
import { ReactComponent as More } from "@src/core/icons/more.svg";
import {
  AddIconWrapper,
  MoreIcon,
  WorkspaceFunctions,
} from "./custom-expand-icon.styles";
import { WorkspaceMenu } from "../workspace-menu";
import { useOutsideClick } from "@src/core/hooks";
import { WorkspaceMenuWrapper } from "../workspace-menu/workspace-menu.styles";
import type { ExpandIconProps } from "./custom-expand-icon.types";
import { useNavigate } from "react-router-dom";
import { APP_ROUTES } from "@src/core/constants";

export const CustomExpandIcon: FC<ExpandIconProps> = memo(
  ({
    spaceId,
    spaceIndex,
    setSpaceIndex,
    handleIconClick,
    deleteWorkspace,
    setSpaceIdByClick,
    handleAccordionChange,
  }) => {
    const [open, setOpen] = useState(false);

    const menuRef = useRef(null);
    const menuInnerRef = useRef(null);
    const navigate = useNavigate();

    const openMenu = (e: SyntheticEvent) => {
      e.stopPropagation();
      setOpen(true);
    };

    const closeMenu = useCallback(() => {
      setOpen(false);
    }, []);

    const methodCreate = (e: SyntheticEvent) => {
      handleIconClick(e);
      navigate(`${APP_ROUTES.WORKSPACE}/${spaceId}${APP_ROUTES.ROUTES}/create`);
      handleAccordionChange(e);
    };

    useOutsideClick(menuRef, closeMenu, menuInnerRef);

    return (
      <Box
        sx={{
          ".Mui-expanded & > .collapsIconWrapper": {
            display: "none",
          },
          ".expandIconWrapper": {
            display: "none",
          },
          ".Mui-expanded & > .expandIconWrapper": {
            display: "block",
          },
        }}
      >
        <div className="expandIconWrapper">
          <WorkspaceFunctions>
            <AddIconWrapper
              className="add-method-icon"
              onClick={(e) => methodCreate(e)}
            >
              <Add />
            </AddIconWrapper>
            <div ref={menuRef}>
              <MoreIcon onClick={(e) => openMenu(e)}>
                <More />
              </MoreIcon>
              <WorkspaceMenuWrapper ref={menuInnerRef}>
                <WorkspaceMenu
                  open={open}
                  spaceId={spaceId}
                  spaceIndex={spaceIndex}
                  setSpaceIndex={setSpaceIndex}
                  deleteWorkspace={deleteWorkspace}
                  setSpaceIdByClick={setSpaceIdByClick}
                />
              </WorkspaceMenuWrapper>
            </div>
          </WorkspaceFunctions>
        </div>
        <div className="collapsIconWrapper">
          <ArrowDown />
        </div>
      </Box>
    );
  },
);
